export default __webpack_public_path__ + "static/media/PassCode 1.87a6c83e.png";